<div class="flex justify-center items-center h-full w-full spinner-material ">
    <mat-spinner diameter="50"></mat-spinner>
</div>